<template>
  <div>
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <!-- Boton para agregar evento -->
      <v-row
      :justify="!$vuetify.breakpoint.mobile ? 'end' : 'center'">
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Agregar Evento"
        iconText="mdi-plus"
        tipo="agregar"
        @click="agregarEventoLicitacion">
      </custom-button>
      </v-row>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EventosLicitacionToolBar',
  components: {
    CustomButton,
  },
  methods: {
    agregarEventoLicitacion() {
      this.$emit('agregarEventoLicitacion');
    },
  },
};
</script>

<style lang="scss">

</style>
